/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */
import Footer from './Footer';
import LaboratoryActionModal from './LaboratoryActionModal';
import NotificationDropdown from './NotificationDropdown';
import { Notification, Question, SelectLang } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';
import SiringManagement from './SiringManagement';
import StadisManagement from './StadisManagement';
import SyringeManagement from './SyringeManagement';

export {
  AvatarDropdown,
  AvatarName,
  Footer,
  Question,
  SelectLang,
  Notification,
  NotificationDropdown,
  SiringManagement,
  StadisManagement,
  SyringeManagement,
  LaboratoryActionModal,
};
